import { render, staticRenderFns } from "./TextareaFieldtype.vue?vue&type=template&id=368902f0&"
import script from "./TextareaFieldtype.vue?vue&type=script&lang=js&"
export * from "./TextareaFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports